/**
 * Whether the page is about to leave on purpose, with the user's word for it.
 *
 * The browser's own "Leave site?" question is for a tab closed by accident. A
 * reload the user has just confirmed in the app, to take an update, would ask
 * again for nothing, so it sets this first. Unsaved work is journalled either
 * way (App.vue), and offered back after the reload.
 */
export const leaving = { confirmed: false }
